import Vue from 'vue'
import Vuex from 'vuex'

// 使用Vuex实例
Vue.use(Vuex)

// 创建Vuex实例
const store = new Vuex.Store({
  state:{
    openId: 0, // 用户openId
    profileImg: '', // 用户头像
    tenantName: '', // 选中的当前学校
    tenantId: 0, // 选中的学校id
    // openID: 'oqX5i6nKjU-GVUgqEXdwnXML3gx8',
    // profileImg: "https://thirdwx.qlogo.cn/mmopen/vi_32/dAjdFoG3JSQiaibF97Tkv2pweNCSL0d4eeLohy9R9SkJ0PRTu37zR9Ur0DtLicKcicxEoAX1SSxia3a9cqHbQMPTFUw/132"
  },
  getters: {
    // 获取openId
    getOpenId(state){
      return state.openId
    },
    // 获取头像
    getImg(state){
      return state.profileImg
    },
  },
  mutations:{
    // 将用户的openId和头像存在Vuex中
    setOpenId(state,payload){
      state.openId = payload.openId
      state.profileImg = payload.profileImg
    },
    // 将用户当前选中的学校存储到vuex中
    setChooseSchool(state,payload){
      state.tenantName = payload.tenantName
      state.tenantId = payload.tenantId
    }
  }
})

 export default store